import React from "react";
import injectSheet from "react-jss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DragSource } from "react-dnd";

const imageSource = {
  beginDrag(props) {
    return {
      id: props.image.id,
      ...(props?.hotspot || {}),
    };
  },
};

const FloorplanHotspotDraggable = DragSource(
  "floorplan-hotspot-draggable",
  imageSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
  }),
)(
  ({
    classes,
    image,
    onDeleteHotspot,
    hotspot,
    style,
    onUnhover,
    connectDragSource,
  }) => {
    return connectDragSource(
      <div
        className={classes.hotspotHoveredContainer}
        style={style}
        onMouseLeave={onUnhover}
      >
        <div className={classes.hotspotIcon} />
        <div className={classes.hotspotHovered}>
          <div className={classes.hotspotInfo}>
            <div className={classes.header}>
              <div className={classes.name}>{image.name}</div>
              <div
                className={classes.delete}
                onClick={e => {
                  e.preventDefault();

                  onDeleteHotspot(hotspot);
                }}
              >
                <FontAwesomeIcon
                  icon={["fal", "trash-alt"]}
                  className={classes.deleteIcon}
                />
              </div>
            </div>
            {!!image.urls.low && (
              <img
                className={classes.image}
                src={image.urls.low}
                alt={image.name}
              />
            )}
          </div>
        </div>
      </div>,
    );
  },
);

class FloorplanHotspot extends React.Component {
  getImage(id) {
    const image = this.props.images.filter(item => item.id === id);
    if (image.length > 0) {
      return image[0];
    }

    const media = this.props.medias?.find(i => i.id === id);
    if (media) {
      const image = media.options?.elements?.find(i => i.type === "image");
      return {
        name: media.options?.title || "",
        urls: {
          low: image?.image?.preview_url || "",
        },
        id,
      };
    }

    return {
      name: "",
      urls: {
        low: "",
      },
    };
  }

  render() {
    const { classes, style, hotspot, onDeleteHotspot, hovered, onHover, onUnhover } =
      this.props;

    if (hovered) {
      const image = this.getImage(hotspot.image);
      return (
        <FloorplanHotspotDraggable
          key={image.id}
          image={image}
          classes={classes}
          hotspot={hotspot}
          style={style}
          onUnhover={onUnhover}
          onDeleteHotspot={onDeleteHotspot}
        />
      );
    } else {
      return (
        <div className={classes.hotspot} style={style}>
          <div onMouseEnter={onHover} className={classes.hotspotIcon} />
        </div>
      );
    }
  }
}

const styles = theme => ({
  hotspot: {
    position: "absolute",
  },
  hotspotIcon: {
    position: "absolute",
    top: -6,
    left: -6,
    width: 12,
    height: 12,
    backgroundColor: theme.colorPrimary,
    border: "1px solid white",
    borderRadius: 6,
    cursor: "move",
    zIndex: 10,
  },
  hotspotHoveredContainer: {
    position: "absolute",
    zIndex: 11,
  },
  hotspotHovered: {
    position: "absolute",
    top: -6,
    left: -6,
  },
  hotspotInfo: {
    marginLeft: 18,
    width: 140,
    padding: theme.spacing2,
    backgroundColor: theme.colorBackground,
    boxSizing: "border-box",
    borderRadius: theme.borderRadius,
  },
  image: {
    width: "100%",
    display: "block",
    pointerEvents: "none",
  },
  header: {
    display: "flex",
    alignItems: "space-between",
    marginBottom: theme.spacing1,
  },
  name: {
    flex: 1,
    fontSize: "0.7rem",
  },
  delete: {
    cursor: "pointer",
  },
  deleteIcon: {
    color: theme.colorSecondary,
  },
});

export default injectSheet(styles)(FloorplanHotspot);
